import React, { useState, useEffect } from 'react';
import { theme } from '../../styled/layout/theme';

interface IMediaQuery {
  breakpoint: keyof typeof theme.screens;
  children: React.ReactNode;
}

const MediaQuery = ({ breakpoint, children }: IMediaQuery) => {
  const mediaQuery = theme.screens[breakpoint];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (mediaQuery && typeof window !== 'undefined') {
      const mql = window.matchMedia(mediaQuery.replace('@media ', ''));
      setVisible(mql.matches);

      const onChange = () => {
        setVisible(mql.matches);
      };

      mql.addEventListener('change', onChange);

      return () => {
        mql.removeEventListener('change', onChange);
      };
    }
  }, [mediaQuery]);

  if (visible) {
    return <>{children}</>;
  }

  return null;
};

export default MediaQuery;
